import { getPathDatabaseByRole } from "../actions/auth";
import { useDispatchApp, useSelectorApp } from "../lib/redux";

/**
 * True when `agenciesFeatureFlags/enterpriseOnlyPlans` includes the current agency.
 * The plans modal then lists only the enterprise option for subscribed agencies.
 */
const useAgencyHasEnterpriseOnlyPlansFeature = () => {
  const dispatch = useDispatchApp();
  const { agencyID } = dispatch(getPathDatabaseByRole());
  const enterpriseOnlyPlansAgencies = useSelectorApp(
    (state) => state.ui.agenciesFeatureFlags?.enterpriseOnlyPlans ?? []
  );

  return enterpriseOnlyPlansAgencies.includes(agencyID);
};

export default useAgencyHasEnterpriseOnlyPlansFeature;
